module.exports = __webpack_public_path__ + "static/media/mark-evans.1b1eda7f.png";